/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareSubCampaign
 */
export interface SterWebsiteModelPriceCompareSubCampaign {
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareSubCampaign
   */
  _package: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareSubCampaign
   */
  grps: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareSubCampaign
   */
  budget?: number;
}

export function SterWebsiteModelPriceCompareSubCampaignFromJSON(
  json: any
): SterWebsiteModelPriceCompareSubCampaign {
  return SterWebsiteModelPriceCompareSubCampaignFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareSubCampaignFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareSubCampaign {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    _package: json["package"],
    grps: json["grps"],
    budget: !exists(json, "budget") ? undefined : json["budget"],
  };
}

export function SterWebsiteModelPriceCompareSubCampaignToJSON(
  value?: SterWebsiteModelPriceCompareSubCampaign | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    package: value._package,
    grps: value.grps,
    budget: value.budget,
  };
}
